
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'GlobeLight' })
export default class GlobeLight extends Vue {}
